import React from 'react'

export function Tooltip({ label, children }: { label: string; children: React.ReactNode }): JSX.Element {
  return (
    <span className="group/tip relative inline-flex">
      {children}
      <span className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-0.5 text-[11px] font-medium text-white opacity-0 shadow-sm transition-opacity duration-150 group-hover/tip:opacity-100">
        {label}
      </span>
    </span>
  )
}
